export enum EPaymentType {
  MONTHLY = 'Monthly',
  ANNUAL = 'Annual',
}
